import { render, staticRenderFns } from "./TableServiceContractDetails.vue?vue&type=template&id=3126d4e7&scoped=true&"
import script from "./TableServiceContractDetails.vue?vue&type=script&lang=js&"
export * from "./TableServiceContractDetails.vue?vue&type=script&lang=js&"
import style0 from "./TableServiceContractDetails.vue?vue&type=style&index=0&id=3126d4e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3126d4e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
